import { render, staticRenderFns } from "./RankDaily.vue?vue&type=template&id=127c255a&scoped=true"
import script from "./RankDaily.vue?vue&type=script&lang=js"
export * from "./RankDaily.vue?vue&type=script&lang=js"
import style0 from "./RankDaily.vue?vue&type=style&index=0&id=127c255a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127c255a",
  null
  
)

export default component.exports